export default __webpack_public_path__ + "static/media/tl-exchanges.bdc02550.png";